export function AccountBar({ user, activeView, setActiveView, onLogout }) {
  return (
    <div className="account-bar" data-testid="account-bar">
      <div><span className="label">SIGNED IN</span><strong data-testid="account-user-email">{user.email}</strong><em>{user.role}</em></div>
      <div className="account-actions">
        <button data-testid="nav-dashboard-button" className={activeView === "dashboard" ? "active" : ""} onClick={() => setActiveView("dashboard")}>Dashboard</button>
        <button data-testid="nav-profile-button" className={activeView === "profile" ? "active" : ""} onClick={() => setActiveView("profile")}>Profile</button>
        {user.role === "admin" && <button data-testid="nav-admin-button" className={activeView === "admin" ? "active" : ""} onClick={() => setActiveView("admin")}>Admin</button>}
        <button data-testid="logout-button" onClick={onLogout}>Logout</button>
      </div>
    </div>
  );
}